<template>
  <div
    ref="swipeable"
    class="w-full flex overflow-auto overflow-x-scroll no-scrollbar snap-mandatory snap-x"
    @touchend="handleSwipe"
  >
    <template v-if="direction === 'ltr' ? $slots.left : $slots.right">
      <slot :name="direction === 'ltr' ? 'left' : 'right'" />
    </template>

    <div class="min-w-full snap-start">
      <slot />
    </div>

    <template v-if="direction === 'ltr' ? $slots.right : $slots.left">
      <slot :name="direction === 'ltr' ? 'right' : 'left'" />
    </template>
  </div>
</template>

<script setup>
import { computed, ref, useSlots } from "vue";
import { storeToRefs } from "pinia";
import { directionStore } from "@/Stores/direction";

const useDirectionStore = directionStore();
const { direction } = storeToRefs(useDirectionStore);

const emit = defineEmits(["left", "right"]);

const swipeable = ref(null);

const props = defineProps({
  minDistance: { type: [Number, String, Function], default: 80 },
});

const width = computed(() => swipeable.value?.clientWidth);

const threshold = computed(() => {
  if (typeof props.minDistance === "function") {
    return props.minDistance(width.value);
  }
  return props.minDistance;
});

function handleSwipe() {
  const swipeDistance = getSwipeDistance();
  if (swipeDistance < threshold.value * -1) {
    emit("left");
  } else if (swipeDistance > threshold.value) {
    emit("right");
  }
}

const slots = useSlots();

function getSwipeDistance() {
  if (
    (direction.value === "ltr" && slots.left) ||
    (direction.value === "rtl" && slots.right)
  ) {
    return swipeable.value?.scrollLeft - width.value;
  }
  return swipeable.value?.scrollLeft;
}
</script>
